export const customV1 = [
  {
    name: 'customV1_startPage',
  },
  {
    name: 'customV1_gender',
  },
  {
    name: 'customV1_age',
  },
  {
    name: 'customV1_breed',
  },
  // {
  //   name: 'customV1_commands',
  // },
  {
    name: 'customV1_descriptionV1',
  },
  {
    name: 'customV1_nervous',
  },
  {
    name: 'customV1_anxious',
  },
  {
    name: 'customV1_stressed',
  },
  {
    name: 'customV1_being_home_alone',
  },
  {
    name: 'customV1_walk',
  },
  {
    name: 'customV1_hygiene',
  },
  {
    name: 'customV1_concern',
  },
  {
    name: 'customV1_dangerous_situation',
  },
  {
    name: 'customV1_these_commands',
  },
  {
    name: 'customV1_eat_something_bad',
  },
  {
    name: 'customV1_this_command',
  },
  {
    name: 'customV1_afraid',
  },
  {
    name: 'customV1_descriptionV2',
  },
  {
    name: 'customV1_when_called',
  },
  {
    name: 'customV1_when_chews',
  },
  {
    name: 'customV1_boundaries',
  },
  {
    name: 'customV1_hard_training',
  },
  {
    name: 'customV1_main_goal',
  },
  {
    name: 'customV1_training_time',
  },
  {
    name: 'customV1_loader',
  },
  {
    name: 'customV1_email',
  },
];
